export default class ApontamentoDiario {
  constructor ({rubrica, valor, dataDeVencimento}) {
    this.rubrica = rubrica
    this.valor = valor
    this.dataDeVencimento = dataDeVencimento
  }
}
